{
  "meta-title-verify-email": "Verify Your Email",
  "verify-email-header": "Whoops—let's do that on your phone instead",
  "verify-email-subheader": "Please use your phone to click that link. That way we can verify your email directly in the Elements app."
}
